const state = {
  bookmark: null,
  query: null,
}

const getters = {
  getBookmark: state => state.bookmark,
  getQuery: state => state.query,
}

const mutations = {
  setBookmark (state, bookmark) {
    state.bookmark = bookmark
  },
  setQuery (state, query) {
    state.query = query
  },
}

const actions = {
  setBookmark ({ commit }, bookmark) {
    commit('setBookmark', bookmark)
  },
  setQuery ({ commit }, query) {
    commit('setQuery', query)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
